import { Box } from '@mui/system'
import React from 'react'
import useTracking from '../hooks/useTracking';

function Contactimgtop() {

    const { ref, handleClick } = useTracking("Contactimgtop");
  return (
   <Box  ref={ref} container  sx={{mx:"20px", maxWidth: "100%",}}>
        <img
          src="/img1/contacttop.png"
          alt="Download on the App Store"
          width="100%"
          height="100%"

          style={{
            cursor: "pointer",
            // maxHeight: "500px", // ✅ Limit max height
            width: "100%",
          }}
       
        />
      </Box>
  )
}

export default Contactimgtop